import styled from '@emotion/styled'

type Props = {
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
  alignItems?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'baseline'
    | 'stretch'
    | 'normal'
  alignSelf?: 'auto' | 'flex-start' | 'flex-end' | 'center' | 'baseline'
  justifySelf?: 'auto' | 'flex-start' | 'flex-end' | 'center' | 'baseline'
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse'
  flex?: string
  gap?: string
  width?: string
  height?: string
  margin?: string
  padding?: string
}
const Flex = styled.div<Props>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-self: ${({ alignSelf }) => alignSelf || 'unset'};
  justify-self: ${({ justifySelf }) => justifySelf || 'unset'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};
  flex-wrap: ${({ flexWrap }) => flexWrap || 'nowrap'};
  flex: ${({ flex }) => flex || 'none'};
  width: ${({ width }) => width || 'unset'};
  height: ${({ height }) => height || 'unset'};
  margin: ${({ margin }) => margin || '0'};
  padding: ${({ padding }) => padding || '0'};
  gap: ${({ gap }) => gap || '0'};
`
export default Flex
